var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanFeature4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87983",
    "data-name": "Group 87983",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.676,
    height: 24.69,
    viewBox: "0 0 24.676 24.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25573",
    "data-name": "Rectangle 25573",
    width: 24.676,
    height: 24.69,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87982",
    "data-name": "Group 87982",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308252",
    "data-name": "Path 308252",
    d: "M7.075,12.586,5.119,10.507a2.338,2.338,0,0,0-1.7-.737H2.609A2.344,2.344,0,0,0,.268,12.118v4.108H4.423V12.5l1.532,1.628a1.053,1.053,0,0,0,.768.332H9.129a.939.939,0,0,0,0-1.878Z",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308253",
    "data-name": "Path 308253",
    d: "M3.54,9.773q-.061,0-.123,0H2.61A2.344,2.344,0,0,0,.269,12.117v4.108H1.323V12.117A2.345,2.345,0,0,1,3.54,9.773Z",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308254",
    "data-name": "Path 308254",
    d: "M5.375,13.515l.581.617a1.053,1.053,0,0,0,.768.332H9.13a.938.938,0,0,0,.936-.949Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308255",
    "data-name": "Path 308255",
    d: "M.269,16.226h4.68A1.658,1.658,0,0,1,6.53,18.071v6.371H4.453V19.16h-2.6A1.581,1.581,0,0,1,.269,17.579Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308256",
    "data-name": "Path 308256",
    d: "M1.323,17.578V16.225H.268v1.353A1.582,1.582,0,0,0,1.85,19.16H2.9a1.582,1.582,0,0,1-1.582-1.582",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308257",
    "data-name": "Path 308257",
    d: "M6.53,22.9a.343.343,0,1,1-.343.343A.343.343,0,0,1,6.53,22.9",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308258",
    "data-name": "Path 308258",
    d: "M2.65,4.42A2.215,2.215,0,1,0,4.864,6.634,2.216,2.216,0,0,0,2.65,4.42",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308259",
    "data-name": "Path 308259",
    d: "M17.6,12.586l1.955-2.079a2.34,2.34,0,0,1,1.7-.737h.807a2.344,2.344,0,0,1,2.341,2.348v4.108H20.252V12.5L18.72,14.132a1.053,1.053,0,0,1-.768.332h-2.4a.939.939,0,0,1,0-1.878Z",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308260",
    "data-name": "Path 308260",
    d: "M21.136,9.773q.062,0,.123,0h.807a2.344,2.344,0,0,1,2.341,2.347v4.108H23.353V12.117A2.345,2.345,0,0,0,21.136,9.773Z",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308261",
    "data-name": "Path 308261",
    d: "M19.3,13.515l-.581.617a1.053,1.053,0,0,1-.768.332H15.546a.938.938,0,0,1-.936-.949Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308262",
    "data-name": "Path 308262",
    d: "M24.407,16.226h-4.68a1.658,1.658,0,0,0-1.581,1.845v6.371h2.077V19.16h2.6a1.581,1.581,0,0,0,1.582-1.581Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308263",
    "data-name": "Path 308263",
    d: "M23.353,17.578V16.225h1.055v1.353a1.582,1.582,0,0,1-1.582,1.582H21.771a1.582,1.582,0,0,0,1.582-1.582",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308264",
    "data-name": "Path 308264",
    d: "M18.146,22.9a.343.343,0,1,1-.343.343.343.343,0,0,1,.343-.343",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308265",
    "data-name": "Path 308265",
    d: "M22.025,4.42a2.215,2.215,0,1,0,2.214,2.214A2.216,2.216,0,0,0,22.025,4.42",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308266",
    "data-name": "Path 308266",
    d: "M17.757,3.246H11.625a.909.909,0,0,0-.908.908V5.971a.908.908,0,0,0,.908.908h4.983l2.057,1.363V4.154a.908.908,0,0,0-.908-.908",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308267",
    "data-name": "Path 308267",
    d: "M6.919.264h6.132a.909.909,0,0,1,.908.908V2.989a.908.908,0,0,1-.908.908H8.068L6.011,5.26V1.172A.908.908,0,0,1,6.919.264",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308268",
    "data-name": "Path 308268",
    d: "M7.974.264H6.919a.909.909,0,0,0-.908.908V5.26l1.055-.7V1.172A.908.908,0,0,1,7.974.264",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308269",
    "data-name": "Path 308269",
    d: "M13.959,3.443V.718a.454.454,0,0,0-.454-.454H13.03a.02.02,0,0,0-.02.02v2.19a.474.474,0,0,1-.475.474H10.757a.475.475,0,1,0,0,.949h2.748A.454.454,0,0,0,13.959,3.443Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308270",
    "data-name": "Path 308270",
    d: "M17.756,2.982H14.222V1.172A1.173,1.173,0,0,0,13.05,0H6.919A1.173,1.173,0,0,0,5.747,1.172V5.259a.265.265,0,0,0,.409.22L8.148,4.16h2.305V5.971a1.173,1.173,0,0,0,1.172,1.172h4.9l1.991,1.318a.265.265,0,0,0,.409-.219V4.154a1.174,1.174,0,0,0-1.172-1.172m-9.688.651a.261.261,0,0,0-.146.044L6.274,4.768v-3.6A.645.645,0,0,1,6.919.527H13.05a.645.645,0,0,1,.645.645V2.988a.645.645,0,0,1-.645.645Zm5.349,1.693h-.854a.264.264,0,1,1,0-.527h.854a.264.264,0,1,1,0,.527Zm3.628,0H14.706a.264.264,0,1,1,0-.527h2.339a.264.264,0,1,1,0,.527Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308271",
    "data-name": "Path 308271",
    d: "M9.969,2.344H7.63a.264.264,0,1,1,0-.527H9.969a.264.264,0,1,1,0,.527",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308272",
    "data-name": "Path 308272",
    d: "M12.113,2.344h-.854a.264.264,0,1,1,0-.527h.854a.264.264,0,1,1,0,.527",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308273",
    "data-name": "Path 308273",
    d: "M24.412,24.163H23.344V19.349a1.848,1.848,0,0,0,1.327-1.771v-5.46a2.612,2.612,0,0,0-2.6-2.612h-.807a2.612,2.612,0,0,0-1.9.82l-1.878,2h-1.94a1.2,1.2,0,0,0-.992,1.878H10.122a1.2,1.2,0,0,0-.993-1.878H7.189l-1.878-2a2.611,2.611,0,0,0-1.895-.82H2.609A2.611,2.611,0,0,0,0,12.118v5.46a1.848,1.848,0,0,0,1.327,1.771v4.814H.264a.264.264,0,1,0,0,.527H24.412a.264.264,0,1,0,0-.527ZM15.546,12.849H17.6a.262.262,0,0,0,.192-.083l1.957-2.079a2.081,2.081,0,0,1,1.51-.653h.807a2.083,2.083,0,0,1,2.078,2.084v3.844H20.516V12.5a.265.265,0,0,0-.455-.18l-1.532,1.628a.8.8,0,0,1-.576.249H15.546a.676.676,0,0,1,0-1.351ZM.532,12.118a2.082,2.082,0,0,1,2.077-2.084h.807a2.083,2.083,0,0,1,1.511.653l1.956,2.079a.265.265,0,0,0,.192.083H9.129a.676.676,0,0,1,0,1.351H6.723a.791.791,0,0,1-.576-.249L4.615,12.323a.265.265,0,0,0-.455.181v3.458H.532ZM4.453,23.44a.263.263,0,0,0,.263-.263V19.16a.263.263,0,0,0-.263-.263H1.85A1.321,1.321,0,0,1,.532,17.578V16.489H4.948a1.32,1.32,0,0,1,1.318,1.318v4.144a.264.264,0,0,0,.528,0V17.807a1.848,1.848,0,0,0-1.846-1.845H4.687V13.169l1.076,1.144a1.326,1.326,0,0,0,.96.415h5.346v9.435H1.859V19.424h2.33v3.753a.264.264,0,0,0,.264.263m15.77.053a.264.264,0,0,0,.264-.264V19.424h2.33v4.739H12.6V14.727h5.357a1.322,1.322,0,0,0,.96-.415l1.076-1.144v2.794h-.262a1.848,1.848,0,0,0-1.845,1.845v4.144a.264.264,0,0,0,.527,0V17.807a1.32,1.32,0,0,1,1.318-1.318h4.416v1.089A1.319,1.319,0,0,1,22.825,18.9h-2.6a.264.264,0,0,0-.264.264v4.069A.264.264,0,0,0,20.223,23.493Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanFeature4);
export default __webpack_public_path__ + "static/media/Plan_Feature_4.457a10d83c8b65dc7e115386219830c1.svg";
export { ForwardRef as ReactComponent };